export interface EventUpdateTarget {
  rawStatus?: string | null;
  rawDate?: string | null;
  date?: string | null;
}

export interface EventUpdateFormData {
  displayName: string;
  eventDate: string;
  eventTime: string;
}

export const isTbdEvent = (event: EventUpdateTarget) => {
  const status = String(event.rawStatus || '').trim().toLowerCase();
  return status.includes('tbd') || !event.rawDate || event.date === 'TBD';
};

export const getEventUpdateValidationError = (
  formData: EventUpdateFormData,
  isTbd: boolean,
  eventDateUtc: string | null,
) => {
  if (!formData.displayName.trim()) return 'Display name is required';
  if (!isTbd && !formData.eventDate) return 'Event date is required';
  if (!isTbd && !eventDateUtc) return 'Enter a valid event date and time';
  return null;
};

export const buildEventUpdatePayload = ({
  formData,
  isTbd,
  eventDateUtc,
  normalizedTime,
  formattedDateTimeZone,
  timeZone,
}: {
  formData: EventUpdateFormData;
  isTbd: boolean;
  eventDateUtc: string | null;
  normalizedTime: string | null;
  formattedDateTimeZone: string | null;
  timeZone?: string | null;
}) => ({
  e_brand_name: formData.displayName.trim(),
  e_is_active_manual_override: true,
  e_date: isTbd ? eventDateUtc : eventDateUtc,
  e_time: isTbd ? normalizedTime || null : normalizedTime,
  ...(formattedDateTimeZone ? { e_date_time_zone: formattedDateTimeZone } : {}),
  ...(timeZone ? { e_time_zone: timeZone } : {}),
});